import axios from "axios";

export const getDataTableTransaksiMasuk = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}akuntan/transaksiMasuk/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}akuntan/transaksiMasuk/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDataTransMasuk = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}akuntan/transaksiMasuk/transMasuk?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}akuntan/transaksiMasuk/transMasuk?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const insertNewTransaksiMasuk = async (formData) => {
  return await axios.post(`${window._HOST}akuntan/transaksiMasuk/`, formData, {
    withCredentials: true,
  });
};

export const deleteTransaksiMasuk = async (id_transaksi_masuk) => {
  return await axios.delete(
    `${window._HOST}akuntan/transaksiMasuk/${id_transaksi_masuk}`,
    { withCredentials: true }
  );
};
